import { useState } from 'react'
import { Eye, EyeOff } from 'lucide-react'
import { useTranslation } from 'react-i18next'

interface PasswordInputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  wrapperClassName?: string
}

const PasswordInput = ({ className, wrapperClassName, ...rest }: PasswordInputProps) => {
  const [isVisible, setIsVisible] = useState(false)
  const { t } = useTranslation('forms')

  const toggleVisibility = () => setIsVisible((prev) => !prev)

  return (
    <div className={`relative${wrapperClassName ? ` ${wrapperClassName}` : ''}`}>
      <input
        type={isVisible ? 'text' : 'password'}
        className={`${className ?? ''} pr-10`}
        {...rest}
      />
      <button
        type="button"
        onClick={toggleVisibility}
        aria-label={isVisible ? t('hidePassword') : t('showPassword')}
        className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-400 hover:text-gray-600 focus:outline-none"
      >
        {isVisible
          ? <EyeOff size={18} aria-hidden="true" />
          : <Eye size={18} aria-hidden="true" />
        }
      </button>
    </div>
  )
}

export default PasswordInput
